import { AlertSeverity } from '@/constants/alertTypes.tsx';
import { Alert as MuiAlert, AlertTitle as MuiAlertTitle, Typography, styled, Icon } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { assertNever } from '@/utils/assertNever.ts';

interface AlertProps {
  severity: AlertSeverity;
  title: string | null;
  titleGutterBottom: boolean | null;
  text: string | null;
}

const severityMain = (theme: Theme, s: AlertSeverity): string => {
  switch (s) {
    case AlertSeverity.ERROR:
      return theme.palette.error.main;
    case AlertSeverity.WARNING:
      return theme.palette.warning.main;
    case AlertSeverity.INFO:
      return theme.palette.info.main;
    case AlertSeverity.SUCCESS:
      return theme.palette.success.main;
    default:
      return assertNever(s);
  }
};

export function Alert({ severity, title, titleGutterBottom, text }: AlertProps) {
  return (
    <StyledAlert
      severity={severity}
      iconMapping={{ warning: <Icon color='warning'>star</Icon> }}
    >
      {title && (
        <MuiAlertTitle gutterBottom={titleGutterBottom ?? true}>
          <Typography
            variant='h4'
            component='span'
          >
            {title}
          </Typography>
        </MuiAlertTitle>
      )}
      {text && <Typography variant='body2'>{text}</Typography>}
    </StyledAlert>
  );
}

const StyledAlert = styled(MuiAlert)`
  border: 1px solid ${({ theme, severity }) => severityMain(theme, severity as AlertSeverity)};
`;
